<template>
  <!-- FORM EXAMPLE -->
  <form class="nx-form" :data-vv-scope="scope" :id="'scope-' + scope"
        :class="{'nx-active' :active}">
    <h2 v-if="scope" class="nx-form-legend">{{ $t("message.form.scopes." + scope) }}</h2>
    <div class="nx-form-fieldset">
      <nx-relation-form
        :label="$t('message.content.relation.relationMoreInfo')"
        name="relationMoreInfo"
        :value="draft.relationMoreInfo"
        :disabled="disabled"
      ></nx-relation-form>
    </div>
  </form>
</template>

<script>
import FormScope from '@/modules/form/FormScope';
import RelationForm from '@/modules/relation/Form';

export default {
  name: 'nx-form-content-multimedia',
  extends: FormScope,
  components: {
    [RelationForm.name]: RelationForm,
  },
};
</script>
